module.exports = __webpack_public_path__ + "img/cent2.13bc8175.jpg";